import Api from '../Api';

class CharityScopesApi extends Api {
  constructor() {
    super('charities/scopes', 'charityscopes');
  }
}
const charityScopesApi = new CharityScopesApi();
export default charityScopesApi;
